/**
 * View component for /admin/users
 *
 * Redirects to the rome admin user list
 */

// import primary libraries
import React from 'react';

import Base from "../../../global/components/BaseComponent.js.jsx";

class AdminUserList extends Base {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const userListUrl = `${window.hubUrl}/super/users`
    window.location.assign(userListUrl);
  }
  render() {
    return <div>Loading...</div>
  }
}

export default AdminUserList;

// export default withRouter(
//   connect(
//     mapStoreToProps
//   )(AdminUserList)
// );



// WEBPACK FOOTER //
// modules/user/views/AdminUserList.js.jsx